import { eventButtons } from './quick-view.js';

document.addEventListener('DOMContentLoaded', () => {
  quantityValues();
  initProductCards();
  eventCart();
});

// The collection grid appends cards as the visitor scrolls (Ajaxinate), after
// the listeners above were bound; product-grid calls this again for them.
window.initProductCards = initProductCards;

// Product cards bind their own quantity controls in initProductCards, so they
// are left out here or re-running that would double every click.
function outsideCards(selector) {
  return Array.from(document.querySelectorAll(selector)).filter(el => !el.closest('.product-card'));
}

function quantityValues() {
  bindQuantity(outsideCards('[js-qty-input]'), outsideCards('[js-qty-minus]'), outsideCards('[js-qty-plus]'));
  outsideCards('[js-product-more]').forEach(bindProductMore);

  const atcBtns = document.querySelectorAll('[js-add-to-cart-quick]');

  atcBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = Number(btn.getAttribute('data-variant-id'));
      const container = btn.closest('.hero-banner__desc');
      let qty = 1;
      if (container) {
        qty = Number(container.querySelector('[js-qty-input]').value);
      }
      addToCart(variantId, qty);
    });
  });
}

function bindQuantity(inputs, qtyMinusBtns, qtyPlusBtns) {
  inputs.forEach(input => {
    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');

      if (input.value === '' || input.value === '0') {
        input.value = '1';
        return;
      }

      const max = parseInt(input.getAttribute('max')) || Infinity;
      let value = parseInt(input.value);

      if (value > max) {
        input.value = max;
      }
    });
  });

  qtyMinusBtns.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const container = button.parentNode;
      const input = container.querySelector('[js-qty-input]');
      let value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
      }
    });
  });

  qtyPlusBtns.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const container = button.parentNode;
      const input = container.querySelector('[js-qty-input]');
      let value = parseInt(input.value) || 1;
      let max = parseInt(input.getAttribute('max')) || Infinity;

      if (value < max) {
        input.value = value + 1;
      }
    });
  });
}

function addToCart(variantId, qty) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: qty
    })
  })
  .then(response => response.json())
  .then(data => {
    renderCart();
  })
  .catch(error => {
    console.error("Error adding to cart:", error);
  });
}

function renderCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    }
  }).then(res => res.json()).then(response => {
    const cart = response;
    const cartNum = document.querySelector('[js-cart-num]');
    if (cartNum) {
      cartNum.innerHTML = cart.item_count;
    }
  });
}

function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart cleared:', data);
    // Optionally refresh cart UI
    location.reload(); // or update cart drawer dynamically
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });
}

function getProductsFromPLP() {
  let products = [];
  const productEls = document.querySelectorAll('#product-card');
  productEls.forEach(item => {
    products.push(item.innerHTML ? JSON.parse(item.innerHTML): null);
  });

  return products;
}

function initProductCards() {
  document.querySelectorAll('.product-card:not([data-card-bound])').forEach(card => {
    card.setAttribute('data-card-bound', '');

    bindQuantity(
      card.querySelectorAll('[js-qty-input]'),
      card.querySelectorAll('[js-qty-minus]'),
      card.querySelectorAll('[js-qty-plus]')
    );

    card.querySelectorAll('[js-add-to-cart-product]').forEach(button => bindAddToCart(button, card));

    card.querySelectorAll('[js-expected-date]').forEach(item => {
      const date = item.getAttribute('data-expected-date');
      let time;
      if (date) {
        time = new Date(date);
        time.setDate(time.getDate() + 1);
      } else {
        time = new Date();
        time.setDate(time.getDate() + 1);
      }
      const options = { month: 'long', day: 'numeric' };
      const formatted = time.toLocaleDateString('en-US', options);
      // Line break so the date ("October 14") always sits together on the second line.
      item.innerHTML = 'Expected<br>' + formatted;
    });

    card.querySelectorAll('[js-notify-button]').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });

    card.querySelectorAll('[js-product-more]').forEach(bindProductMore);
  });
}

// Opens the quick view popup for a product whose JSON sits on the page
// (<script id="product-card">), e.g. the cart's suggested products.
function bindProductMore(button) {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const productId = button.getAttribute('data-product-id');
    const maxCount = button.getAttribute('data-product-max') ? Number(button.getAttribute('data-product-max')) : 100;
    const products = getProductsFromPLP();
    products.forEach(product => {
      if (product && product.id == Number(productId)) {
        renderModalData(product, maxCount);
      }
    });
  });
}

function bindAddToCart(button, container) {
  const price = container.querySelector('[js-product-price]');
  const metaEl = container.querySelector('[js-product-meta]');
  // The card's Learn More link no longer carries js-product-more, so this can be null.
  const moreBtn = container.querySelector('[js-product-more]');
  const metaText = metaEl ? metaEl.innerHTML : '';

  button.addEventListener('mouseover', () => {
    const qtyInput = container.querySelector('[js-qty-input]');
    if (!price || !metaEl || !qtyInput) return;
    const qty = qtyInput.value;
    const priceVal = price.getAttribute('data-price');
    const pcsArr = [
      {
        count:8,
        percentage: 0.5
      },
      {
        count:24,
        percentage: 0.47
      },
      {
        count:48,
        percentage: 0.42
      },
      {
        count:120,
        percentage: 0.38
      },
      {
        count:240,
        percentage: 0.26
      },
      {
        count:480,
        percentage: 0.24
      },
      {
        count:1100,
        percentage: 0.19
      }
    ];

    let percentage = 1;
    pcsArr.forEach(item => {
      if (item.count <= qty) {
        percentage = item.percentage;
      }
    });

    const totalPrice = Number(qty) * (Number(priceVal) * percentage);
    price.innerHTML = formatMoney(totalPrice);
    price.classList.remove('hidden');
    if (moreBtn) moreBtn.classList.add('hidden');

    if (qty == 1) {
      metaEl.innerHTML = qty + ' pc';
    }
    else {
      metaEl.innerHTML = qty + ' pcs';
    }
  });

  button.addEventListener('mouseleave', () => {
    if (moreBtn) moreBtn.classList.remove('hidden');
    if (price) price.classList.add('hidden');
    if (metaEl) metaEl.innerHTML = metaText;
  });

  button.addEventListener('click', (e) => {
    e.preventDefault();
    const idInput = container.querySelector('form input[name="id"]');
    const qtyInput = container.querySelector('[js-qty-input]');
    const variantId = idInput && idInput.value ? Number(idInput.value) : -1;
    const qty = qtyInput && qtyInput.value ? Number(qtyInput.value) : 1;
    if (variantId == -1) return;
    addToCart(variantId, qty);
  });
}

function renderModalData(product, maxCount) {
  const modal = document.querySelector('[js-quick-view]');
  if (modal) {
    const modalContent = modal.querySelector('[js-quick-view-content]');
    document.body.style.overflow = 'hidden';
    let listHtml = '';
    const pcsArr = [
      {
        count:8,
        percentage: 0.5
      },
      {
        count:24,
        percentage: 0.47
      },
      {
        count:48,
        percentage: 0.42
      },
      {
        count:120,
        percentage: 0.38
      },
      {
        count:240,
        percentage: 0.26
      },
      {
        count:480,
        percentage: 0.24
      },
      {
        count:1100,
        percentage: 0.19
      }
    ];

    pcsArr.forEach(pcs => {
      let isSold = false;
      if (pcs.count >= maxCount) {
        isSold = true;
      }

      listHtml += `
        <li ${isSold ? 'class="disabled"': ''}>
          <span>${pcs.count} pcs</span>
          <button js-add-to-cart-quick data-count="${pcs.count}" data-id="${product.variants[0].id}">Add to cart</button>
          <span>${formatMoney(product.price * pcs.percentage)} / pc</span>
        </li>
      `;
    });

    const html = `
      <div class="product-info">
        <h3 class="product-info__title">${product.title}</h3>
        <div class="product-info__price">
          ${formatMoney(product.price)}
        </div>

        <div class="product-info__variant">
          <span js-qty-value>1 pcs</span>
          <button js-add-to-cart-quick data-id="${product.variants[0].id}" data-count="1">Add to cart</button>
          <span js-price-value data-price="${product.price}">${formatMoney(product.price)} / pc</span>
        </div>

        <div class="quanity_wrapper" js-qty-container>
          <button class="quantity_btn quantity_btn-minus" js-qty-minus>
            <svg width="12" height="3" viewBox="0 0 12 3" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.96 2.504V0.632H11.04V2.504H0.96Z" fill="white"/>
            </svg>
          </button>
          <input min="1" type="text" js-qty-input name="quantity" value="1" max="${maxCount}"/>
          <button class="quantity_btn quantity_btn-minus" js-qty-plus>
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.96963 5.688H11.7456V7.392H6.96963V12.336H5.24163V7.392H0.465625V5.688H5.24163V0.719999H6.96963V5.688Z" fill="white"/>
            </svg>
          </button>
        </div>

        <ul class="product-info__list">
          ${listHtml}
        </ul>

        <button class="quick-view-modal__closebtn" js-quick-view-closebtn>
          <span>close</span>
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.2351 0.47462C22.868 -0.158189 23.8922 -0.158223 24.5251 0.47462C25.1588 1.10756 25.1587 2.13165 24.5251 2.76466L14.7907 12.5L24.5251 22.2354C25.1588 22.8683 25.1588 23.8924 24.5251 24.5254C24.209 24.8408 23.7945 25 23.3796 25C22.9649 24.9999 22.5511 24.8414 22.2351 24.5254L12.4997 14.791L2.76534 24.5254C2.44923 24.8408 2.03473 25 1.61984 25C1.20506 24.9999 0.790569 24.8414 0.475304 24.5254C-0.158435 23.8924 -0.158435 22.8684 0.475304 22.2354L10.2097 12.5L0.475304 2.76466C-0.158354 2.13165 -0.158408 1.10759 0.475304 0.47462C1.10904 -0.158152 2.13243 -0.158262 2.76534 0.47462L12.4997 10.21L22.2351 0.47462Z" fill="white"/>
          </svg>
        </button>
      </div>
    `;

    modalContent.innerHTML = html;
    modal.classList.add('active');
    handleQuickView();
    eventButtons();
  }
}

// Delegated: cart-ajax.js re-renders the cart body after a quantity change,
// replacing the button a direct listener would have been bound to.
function eventCart() {
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[js-clear-card]')) return;
    e.preventDefault();

    clearCart();
  });
}

function handleQuickView () {
  const isCart = document.querySelector('#is-cart') ? true: false;

  const quickAddButtons = document.querySelectorAll('[js-add-to-cart-quick]');
  quickAddButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const qty = button.getAttribute('data-count') ? Number(button.getAttribute('data-count')) : 0;
      const id = button.getAttribute('data-id') ? Number(button.getAttribute('data-id')): -1;
      if (id != -1 && qty != 0) {
        addToCart(id, qty);
        const modal = document.querySelector('[js-quick-view]');

        if (isCart) {
          window.location.href = '/cart';
        } else {
          if (modal) {
            modal.classList.remove('active');
            document.body.style.overflowY = 'auto';
          }
        }
      }
    });
  });

  const qtyPlusBtns = document.querySelectorAll('.product-info [js-qty-plus]');
  const qtyMinusBtns = document.querySelectorAll('.product-info [js-qty-minus]');
  const inputs = document.querySelectorAll('.product-info [js-qty-input]');

  inputs.forEach(input => {
    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');

      if (input.value === '' || input.value === '0') {
        input.value = '1';
        return;
      }

      const max = parseInt(input.getAttribute('max')) || Infinity;
      let value = parseInt(input.value);

      if (value > max) {
        input.value = max;
      }

      updateValuesOnMain(input.value);
    });
  });

  qtyPlusBtns.forEach(plus => {
    plus.addEventListener('click', (e) => {
      e.preventDefault();

      const container = plus.parentNode;
      const input = container.querySelector('[js-qty-input]');
      let value = parseInt(input.value) || 1;
      let max = parseInt(input.getAttribute('max')) || Infinity;

      if (value < max) {
        input.value = value + 1;
      }

      updateValuesOnMain(input.value);
    });
  });

  qtyMinusBtns.forEach(minus => {
    minus.addEventListener('click', (e) => {
      e.preventDefault();

      const container = minus.parentNode;
      const input = container.querySelector('[js-qty-input]');
      let value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
      }

      updateValuesOnMain(input.value);
    });
  });

  function updateValuesOnMain(value) {
    const quickATCBtn = document.querySelector('.product-info__variant [js-add-to-cart-quick]');
    const quickPcs = document.querySelector('.product-info__variant [js-qty-value]');
    const quickPrice = document.querySelector('.product-info__variant [js-price-value]');

    if (quickATCBtn) {
      quickATCBtn.setAttribute('data-count', value);
      quickPcs.innerHTML = `${value} pcs`;

      const pcsArr = [
        {
          count:8,
          percentage: 0.5
        },
        {
          count:24,
          percentage: 0.47
        },
        {
          count:48,
          percentage: 0.42
        },
        {
          count:120,
          percentage: 0.38
        },
        {
          count:240,
          percentage: 0.26
        },
        {
          count:480,
          percentage: 0.24
        },
        {
          count:1100,
          percentage: 0.19
        }
      ];
      const orgPrice = quickPrice.getAttribute('data-price') ? Number(quickPrice.getAttribute('data-price')): 0;

      let percentage = 1;
      pcsArr.forEach(item => {
        if (value >= item.count) {
          percentage = item.percentage;
        }
      });
      quickPrice.innerHTML = `${formatMoney(orgPrice * percentage)} / pc`;
    }
  }
}
//
function formatMoney(amount, locale = 'nl-NL', currency = 'EUR') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount / 100);
}